import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const api = axios.create({ baseURL: API, withCredentials: true });
// Sesiunea s-a închis pentru că parola contului a fost schimbată (de utilizator, pe alt dispozitiv, sau resetată de un administrator):
// păstrăm explicația pentru pagina de autentificare, ca utilizatorul să știe de ce a fost deconectat.
api.interceptors.response.use(r => r, (err) => {
  const d = err?.response?.data?.detail;
  if (err?.response?.status === 401 && typeof d === "string" && d.includes("parola s-a schimbat")) {
    try { sessionStorage.setItem("onomad_login_notice", "Ați fost deconectat pentru că parola contului a fost schimbată. Autentificați-vă din nou cu parola nouă."); } catch { /* fără stocare */ }
  }
  return Promise.reject(err);
});
export default api;
export function takeLoginNotice() {
  try { const t = sessionStorage.getItem("onomad_login_notice"); if (t) sessionStorage.removeItem("onomad_login_notice"); return t || ""; } catch { return ""; }
}
export { API };

/**
 * Textul unei erori de la server, cât mai concret: mesajul din `detail` (text sau listă de validare), altfel
 * codul HTTP + ce a întors serverul; fără răspuns deloc = problemă de rețea/server.
 */
export function errorText(e, fallback = "Eroare") {
  const r = e?.response;
  if (!r) return `${fallback}: nu am primit răspuns de la server (${e?.message || "problemă de rețea"}).`;
  const d = r.data?.detail;
  if (typeof d === "string" && d.trim()) return d;
  if (Array.isArray(d) && d.length) return d.map(x => (typeof x === "string" ? x : `${(x.loc || []).filter(l => l !== "body").join(".")}: ${x.msg}`)).join("; ");
  if (d && typeof d === "object") return JSON.stringify(d);
  const raw = typeof r.data === "string" ? r.data.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim().slice(0, 200) : "";
  return `${fallback}: serverul a răspuns ${r.status}${r.statusText ? " " + r.statusText : ""}${raw ? " — " + raw : ""}.`;
}

/** Citire tolerantă: o sursă secundară care lipsește (fără drept) dă `fallback`, nu o pagină goală sau o eroare. */
export const soft = (req, fallback) => req.catch(() => ({ data: fallback }));
